"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var Logout = function Logout(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "Logout"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "logout"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.1 10.96c0 0.005 0 0.011 0 0.017 0 4.474-3.626 8.1-8.1 8.1s-8.1-3.626-8.1-8.1c0-2.888 1.511-5.423 3.787-6.857l0.033-0.020c0.133-0.074 0.292-0.118 0.461-0.118 0.515 0 0.936 0.406 0.959 0.916l0 0.002c-0.004 0.349-0.194 0.653-0.475 0.818l-0.005 0.002c-1.731 1.119-2.86 3.039-2.86 5.223 0 3.424 2.776 6.2 6.2 6.2s6.2-2.776 6.2-6.2c0-2.184-1.129-4.104-2.836-5.209l-0.024-0.015c-0.28-0.164-0.468-0.459-0.48-0.798l-0-0.002c0.013-0.52 0.437-0.938 0.96-0.938 0.169 0 0.327 0.044 0.465 0.12l-0.005-0.002c2.307 1.448 3.818 3.977 3.82 6.86v0zM10 10.96c0.53 0 0.96-0.43 0.96-0.96v0-8.1c0-0.53-0.43-0.96-0.96-0.96s-0.96 0.43-0.96 0.96v0 8.1c0 0.53 0.43 0.96 0.96 0.96v0z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = Logout;
exports["default"] = _default;